import React, { Component } from 'react';
import { ArrowLeft, Phone, MessageSquare, Calendar, Package, User, Building2, Clock, Search, FileText, Loader, ChevronLeft, ChevronRight } from 'lucide-react';
import axios from 'axios';
import Cookies from "universal-cookie";
import moment from 'moment-timezone';
import host from "./host";

const cookies = new Cookies();

class OrderDetailsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            orders: [],
            loading: true,
            error: null,
            currentStatus: 'كاذب',
            selectedOrderId: null,
            // Pagination states
            currentPage: 1,
            totalPages: 1,
            totalCount: 0,
            pageSize: 10,
            hasNextPage: false,
            hasPrevPage: false,
            // Search state
            searchTimeout: null
        };
    }

    componentDidMount() {
        this.fetchOrders();
    }

    // جلب الطلبات من API مع Pagination والبحث
    fetchOrders = async (status = 'كاذب', page = 1, searchTerm = '') => {
        try {
            this.setState({ loading: true, error: null });

            const encodedStatus = encodeURIComponent(status);
            let url = `${host}users/kadebmtab3a-orders?status=${encodedStatus}&page=${page}&limit=${this.state.pageSize}`;
            
            // إضافة البحث إذا كان موجود
            if (searchTerm && searchTerm.trim() !== '') {
                url += `&search=${encodeURIComponent(searchTerm.trim())}`;
            }

            const response = await axios.get(url);

            this.setState({
                orders: response.data.orders || [],
                currentPage: response.data.pagination?.currentPage || 1,
                totalPages: response.data.pagination?.totalPages || 1,
                totalCount: response.data.pagination?.totalCount || 0,
                hasNextPage: response.data.pagination?.hasNextPage || false,
                hasPrevPage: response.data.pagination?.hasPrevPage || false,
                loading: false,
                currentStatus: status
            });
        } catch (error) {
            console.error('Error fetching orders:', error);
            this.setState({
                error: 'حدث خطأ في جلب البيانات',
                loading: false
            });
        }
    };

    // انتقال للصفحة التالية
    handleNextPage = () => {
        if (this.state.hasNextPage) {
            const nextPage = this.state.currentPage + 1;
            this.fetchOrders(this.state.currentStatus, nextPage, this.state.searchTerm);
        }
    };

    // انتقال للصفحة السابقة
    handlePrevPage = () => {
        if (this.state.hasPrevPage) {
            const prevPage = this.state.currentPage - 1;
            this.fetchOrders(this.state.currentStatus, prevPage, this.state.searchTerm);
        }
    };

    // انتقال لصفحة محددة
    handlePageChange = (page) => {
        if (page >= 1 && page <= this.state.totalPages) {
            this.fetchOrders(this.state.currentStatus, page, this.state.searchTerm);
        }
    };

    // البحث في الطلبات مع debounce
    handleSearch = (e) => {
        const searchTerm = e.target.value;
        this.setState({ searchTerm });

        // إلغاء البحث السابق
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }

        // تأخير البحث لمدة 500ms لتجنب الطلبات المتكررة
        const timeout = setTimeout(() => {
            this.fetchOrders(this.state.currentStatus, 1, searchTerm);
        }, 500);

        this.setState({ searchTimeout: timeout });
    };

    // مسح البحث
    clearSearch = () => {
        this.setState({ searchTerm: '' });
        this.fetchOrders(this.state.currentStatus, 1, '');
    };

    // إجراء مكالمة
    handleCall = (phoneNumber) => {
        window.open(`tel:${phoneNumber}`);
    };

    // تحويل للواتساب
    handleWhatsApp = (phoneNumber) => {
        let formattedPhone = phoneNumber;
        if (phoneNumber.startsWith('07')) {
            formattedPhone = '964' + phoneNumber.substring(1);
        }
        window.open(`https://wa.me/${formattedPhone}`);
    };

    // فتح مودل المعالجة
    openModal = (orderId) => {
        this.setState({ showModal: true, selectedOrderId: orderId });
    };

    // إغلاق المودل
    closeModal = () => {
        this.setState({
            showModal: false,
            selectedStatus: '',
            postponeDate: '',
            selectedOrderId: null
        });
    };

    // تغيير الحالة المختارة
    handleStatusChange = (status) => {
        this.setState({ selectedStatus: status });
    };

    // تغيير التاريخ
    handleDateChange = (e) => {
        this.setState({ postponeDate: e.target.value });
    };

    // تحويل التاريخ من YYYY-MM-DD إلى DD/MM/YYYY
    formatDateForAPI = (dateString) => {
        try {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch {
            return dateString;
        }
    };

    // إرسال التحديث
    handleSubmit = async () => {
        try {
            this.setState({ loading: true });

            const requestData = {
                id: this.state.selectedOrderId,
                status: this.state.selectedStatus
            };

            if (this.state.selectedStatus === 'مؤجل' && this.state.postponeDate) {
                requestData.Delayed = this.formatDateForAPI(this.state.postponeDate);
            }

            const response = await axios.post(`${host}users/mtab3a-orders/update/`, requestData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': cookies.get("token")
                }
            });

            alert('تم تحديث الحالة بنجاح');
            this.closeModal();
            await this.fetchOrders(this.state.currentStatus, this.state.currentPage, this.state.searchTerm);

        } catch (error) {
            console.error('تفاصيل الخطأ:', error);
            let errorMessage = 'حدث خطأ في تحديث الحالة';

            if (error.response) {
                errorMessage = `خطأ من الخادم: ${error.response.status} - ${error.response.data.message || error.response.data}`;
            } else if (error.request) {
                errorMessage = 'لم يتم الحصول على رد من الخادم. تحقق من الاتصال.';
            } else {
                errorMessage = `خطأ في الطلب: ${error.message}`;
            }

            alert(errorMessage);
        } finally {
            this.setState({ loading: false });
        }
    };

    // العودة للصفحة السابقة
    goBack = () => {
        window.history.back();
    };

    // فك ترميز النص العربي
    decodeArabicText = (text) => {
        try {
            return decodeURIComponent(text.replace(/\+/g, ' '));
        } catch {
            return text;
        }
    };

    // تنسيق التاريخ النسبي (منذ كم دقيقة/ساعة/يوم)
    formatRelativeTime = (dateString) => {
        try {
            const now = moment().tz('Asia/Baghdad');
            const date = moment(dateString).tz('Asia/Baghdad');
            const diffInMinutes = now.diff(date, 'minutes');
            const diffInHours = now.diff(date, 'hours');
            const diffInDays = now.diff(date, 'days');

            if (diffInMinutes < 1) {
                return 'الآن';
            } else if (diffInMinutes < 60) {
                return `منذ ${diffInMinutes} دقيقة`;
            } else if (diffInHours < 24) {
                return `منذ ${diffInHours} ساعة`;
            } else if (diffInDays < 7) {
                return `منذ ${diffInDays} يوم`;
            } else {
                return date.format('DD/MM/YYYY HH:mm');
            }
        } catch {
            return dateString;
        }
    };

    // تنسيق التاريخ بتوقيت بغداد بدون ثواني
    formatDate = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY HH:mm');
        } catch {
            return dateString;
        }
    };

    // تنسيق التاريخ فقط بدون وقت
    formatDateOnly = (dateString) => {
        try {
            return moment(dateString)
                .tz('Asia/Baghdad')
                .format('DD/MM/YYYY');
        } catch {
            return dateString;
        }
    };

    // تحديد ما إذا كان الجهاز موبايل
    isMobile = () => {
        return window.innerWidth <= 768;
    };

    // عرض أرقام الصفحات للموبايل
    renderMobilePaginationNumbers = () => {
        const { currentPage, totalPages } = this.state;
        const pages = [];
        
        // عرض 3 صفحات فقط للموبايل
        if (totalPages <= 3) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(i);
            }
        } else {
            if (currentPage === 1) {
                pages.push(1, 2, 3);
            } else if (currentPage === totalPages) {
                pages.push(totalPages - 2, totalPages - 1, totalPages);
            } else {
                pages.push(currentPage - 1, currentPage, currentPage + 1);
            }
        }

        return pages;
    };

    // عرض أرقام الصفحات
    // عرض أرقام الصفحات
    renderPaginationNumbers = () => {
        const { currentPage, totalPages } = this.state;
        
        // استخدام pagination مبسط للموبايل
        if (this.isMobile()) {
            return this.renderMobilePaginationNumbers();
        }
        
        const pages = [];
        const maxPagesToShow = 5;
        
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
        
        if (endPage - startPage + 1 < maxPagesToShow) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return pages;
    };

    render() {
        const {
            searchTerm,
            orders,
            showModal,
            selectedStatus,
            postponeDate,
            loading,
            error,
            currentPage,
            totalPages,
            totalCount,
            hasNextPage,
            hasPrevPage
        } = this.state;

        const statusOptions = ['لايرد', 'كاذب', 'شركة التوصيل', 'خطأ بالتجهيز', 'مؤجل', 'تم المعالجة'];

        const styles = {
            container: {
                minHeight: '100vh',
                backgroundColor: '#f8fafc',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                direction: 'rtl'
            },
            header: {
                backgroundColor: '#ffffff',
                padding: '1rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                position: 'sticky',
                top: 0,
                zIndex: 10
            },
            headerContent: {
                maxWidth: '768px',
                margin: '0 auto'
            },
            topRow: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '1rem'
            },
            pageTitle: {
                fontSize: '1.5rem',
                fontWeight: 'bold',
                color: '#1f2937',
                textAlign: 'center',
                flex: 1,
                marginRight: '1rem'
            },
            searchRow: {
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '0.5rem',
                position: 'relative'
            },
            totalCount: {
                backgroundColor: '#dbeafe',
                color: '#1e40af',
                padding: '0.5rem 1rem',
                borderRadius: '0.5rem',
                fontSize: '0.875rem',
                fontWeight: '600',
                textAlign: 'center'
            },
            searchLabel: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                whiteSpace: 'nowrap'
            },
            backButton: {
                padding: '0.75rem',
                backgroundColor: '#e2e8f0',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'background-color 0.2s',
                minWidth: '48px',
                height: '48px'
            },
            searchInput: {
                flex: 1,
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                fontSize: '1rem',
                textAlign: 'right',
                paddingLeft: searchTerm ? '2.5rem' : '0.75rem'
            },
            clearButton: {
                position: 'absolute',
                left: '0.75rem',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: '#6b7280',
                fontSize: '1.2rem',
                padding: '0.25rem',
                borderRadius: '50%',
                display: searchTerm ? 'block' : 'none'
            },
            content: {
                maxWidth: '768px',
                margin: '0 auto',
                padding: '1rem'
            },
            loading: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '200px',
                flexDirection: 'column',
                gap: '1rem'
            },
            error: {
                backgroundColor: '#fee2e2',
                color: '#dc2626',
                padding: '1rem',
                borderRadius: '0.5rem',
                textAlign: 'center'
            },
            orderCard: {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                padding: '1.5rem',
                marginBottom: '1rem',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                border: '1px solid #e5e7eb'
            },
            orderHeader: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem',
                paddingBottom: '1rem',
                borderBottom: '1px solid #e5e7eb'
            },
            orderNumber: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#1f2937'
            },
            price: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                color: '#059669'
            },
            section: {
                marginBottom: '1.5rem'
            },
            sectionTitle: {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#374151',
                marginBottom: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            customerInfo: {
                backgroundColor: '#f9fafb',
                padding: '1rem',
                borderRadius: '0.5rem',
                marginBottom: '1rem'
            },
            phoneButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '0.5rem'
            },
            phoneButton: {
                padding: '0.5rem 1rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '0.875rem',
                fontWeight: '500'
            },
            callButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            whatsappButton: {
                backgroundColor: '#25d366',
                color: 'white'
            },
            itemsList: {
                backgroundColor: '#f0f9ff',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: '2px solid #0ea5e9',
                boxShadow: '0 2px 8px rgba(14, 165, 233, 0.1)'
            },
            item: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '1rem',
                marginBottom: '0.5rem',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                borderRight: '4px solid #0ea5e9',
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                fontSize: '1rem',
                fontWeight: '500'
            },
            historyItem: {
                backgroundColor: '#f3f4f6',
                padding: '0.75rem',
                borderRadius: '0.5rem',
                marginBottom: '0.5rem',
                borderRight: '4px solid #3b82f6'
            },
            timeStamp: {
                fontSize: '0.9rem',
                fontWeight: 'bold',
                color: '#059669',
                backgroundColor: '#d1fae5',
                padding: '0.25rem 0.75rem',
                borderRadius: '1rem',
                display: 'inline-block',
                marginTop: '0.5rem',
                border: '1px solid #10b981'
            },
            deliveryCompany: {
                backgroundColor: '#fef3c7',
                padding: '1rem',
                borderRadius: '0.5rem',
                border: '2px solid #f59e0b',
                marginBottom: '1rem'
            },
            deliveryCompanyName: {
                fontSize: '1.2rem',
                fontWeight: 'bold',
                color: '#92400e',
                marginBottom: '0.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
            },
            deliveryDate: {
                fontSize: '0.9rem',
                color: '#78716c',
                fontWeight: '500'
            },
            processButton: {
                width: '100%',
                padding: '1rem',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.5rem',
                fontSize: '1.1rem',
                fontWeight: '600',
                cursor: 'pointer',
                marginTop: '1rem'
            },
            pagination: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem',
                marginTop: '2rem',
                padding: '1rem',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                flexWrap: 'wrap'
            },
            paginationButton: {
                padding: '0.75rem 1rem',
                border: '1px solid #d1d5db',
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.25rem',
                transition: 'all 0.2s',
                minWidth: '44px',
                minHeight: '44px',
                justifyContent: 'center'
            },
            paginationButtonMobile: {
                padding: '0.5rem 0.75rem',
                fontSize: '0.8rem',
                minWidth: '40px',
                minHeight: '40px'
            },
            paginationButtonActive: {
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#3b82f6'
            },
            paginationButtonDisabled: {
                backgroundColor: '#f9fafb',
                color: '#9ca3af',
                cursor: 'not-allowed'
            },
            paginationInfo: {
                fontSize: '0.8rem',
                color: '#6b7280',
                margin: '0.5rem',
                textAlign: 'center',
                width: '100%',
                '@media (min-width: 640px)': {
                    width: 'auto',
                    margin: '0 1rem'
                }
            },
            paginationNumbers: {
                display: 'flex',
                gap: '0.25rem',
                flexWrap: 'wrap',
                justifyContent: 'center'
            },
            paginationNavButtons: {
                display: 'flex',
                gap: '0.5rem',
                width: '100%',
                justifyContent: 'space-between',
                '@media (min-width: 640px)': {
                    width: 'auto'
                }
            },
            modal: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1000,
                padding: '1rem'
            },
            modalContent: {
                backgroundColor: 'white',
                borderRadius: '1rem',
                padding: '2rem',
                maxWidth: '400px',
                width: '100%',
                maxHeight: '80vh',
                overflowY: 'auto'
            },
            modalTitle: {
                fontSize: '1.25rem',
                fontWeight: 'bold',
                marginBottom: '1rem',
                textAlign: 'center'
            },
            statusOption: {
                padding: '0.75rem',
                margin: '0.25rem 0',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                textAlign: 'center',
                transition: 'all 0.2s'
            },
            statusOptionSelected: {
                backgroundColor: '#3b82f6',
                color: 'white',
                borderColor: '#3b82f6'
            },
            statusOptionCompleted: {
                backgroundColor: '#10b981',
                color: 'white',
                borderColor: '#10b981',
                fontWeight: 'bold'
            },
            dateInput: {
                width: '100%',
                padding: '0.75rem',
                border: '1px solid #d1d5db',
                borderRadius: '0.5rem',
                marginTop: '1rem'
            },
            modalButtons: {
                display: 'flex',
                gap: '0.5rem',
                marginTop: '1.5rem'
            },
            modalButton: {
                flex: 1,
                padding: '0.75rem',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                fontWeight: '600'
            },
            submitButton: {
                backgroundColor: '#10b981',
                color: 'white'
            },
            cancelButton: {
                backgroundColor: '#6b7280',
                color: 'white'
            },
            noData: {
                textAlign: 'center',
                padding: '2rem',
                color: '#6b7280'
            }
        };

        if (loading) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.loading}>
                            <Loader className="animate-spin" size={40} />
                            <p>جاري تحميل الطلبات...</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div style={styles.container}>
                    <div style={styles.content}>
                        <div style={styles.error}>
                            {error}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <div style={styles.headerContent}>
                        <div style={styles.topRow}>
                            <button style={styles.backButton} onClick={this.goBack}>
                                <ArrowLeft size={24} />
                            </button>
                            <div style={styles.pageTitle}>الطلبات الكاذبة</div>
                        </div>
                        <div style={styles.searchRow}>
                            <div style={styles.searchLabel}>البحث عن طلب:</div>
                            <div style={{ position: 'relative', flex: 1 }}>
                                <input
                                    type="text"
                                    placeholder="ابحث برقم الطلب أو رقم الهاتف في جميع الصفحات..."
                                    value={searchTerm}
                                    onChange={this.handleSearch}
                                    style={styles.searchInput}
                                />
                                {searchTerm && (
                                    <button
                                        style={styles.clearButton}
                                        onClick={this.clearSearch}
                                        title="مسح البحث"
                                    >
                                        ✕
                                    </button>
                                )}
                            </div>
                        </div>
                        <div style={styles.totalCount}>
                            إجمالي الطلبات: {totalCount.toLocaleString()} طلب
                        </div>
                    </div>
                </div>

                {/* Content */}
                <div style={styles.content}>
                    {orders.length === 0 ? (
                        <div style={styles.noData}>
                            {searchTerm ? 'لا توجد طلبات متطابقة مع البحث' : 'لا توجد طلبات'}
                        </div>
                    ) : (
                        orders.map(order => (
                            <div key={order.id} style={styles.orderCard}>
                                {/* Order Header */}
                                <div style={styles.orderHeader}>
                                    <div style={styles.orderNumber}>طلب رقم: {order.id}</div>
                                    <div style={styles.price}>{order.price.toLocaleString()} د.ع</div>
                                </div>

                                {/* Customer Info */}
                                <div style={styles.section}>
                                    <div style={styles.sectionTitle}>
                                        <User size={20} />
                                        معلومات الزبون
                                    </div>
                                    <div style={styles.customerInfo}>
                                        <div><strong>الاسم:</strong> {this.decodeArabicText(order.name) || 'غير محدد'}</div>
                                        <div><strong>الهاتف:</strong> {order.phone}</div>
                                        <div style={styles.phoneButtons}>
                                            <button
                                                style={{ ...styles.phoneButton, ...styles.callButton }}
                                                onClick={() => this.handleCall(order.phone)}
                                            >
                                                <Phone size={16} />
                                                اتصال
                                            </button>
                                            <button
                                                style={{ ...styles.phoneButton, ...styles.whatsappButton }}
                                                onClick={() => this.handleWhatsApp(order.phone)}
                                            >
                                                <MessageSquare size={16} />
                                                واتساب
                                            </button>
                                        </div>
                                        <div style={{ marginTop: '0.5rem' }}>
                                            <strong>العنوان:</strong> {this.decodeArabicText(order.government)} - {this.decodeArabicText(order.city)}
                                        </div>
                                    </div>
                                </div>

                                {/* Delivery Company - Enhanced */}
                                {order.printerOrders && order.printerOrders.length > 0 && (
                                    <div style={styles.section}>
                                        <div style={styles.deliveryCompany}>
                                            <div style={styles.deliveryCompanyName}>
                                                <Building2 size={20} />
                                                شركة التوصيل: {this.decodeArabicText(order.printerOrders[0].prints.name)}
                                            </div>
                                            <div style={styles.deliveryDate}>
                                                تاريخ ترحيل الطلب: {this.formatDateOnly(order.printerOrders[0].prints.createdAt)}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Items */}
                                <div style={styles.section}>
                                    <div style={styles.sectionTitle}>
                                        <Package size={20} />
                                        مواد الطلب
                                    </div>
                                    <div style={styles.itemsList}>
                                        {order.ordersFormItems && order.ordersFormItems.map((item, index) => (
                                            <div key={index} style={styles.item}>
                                                <span>{this.decodeArabicText(item.components.name)}</span>
                                                <span><strong>العدد: {item.count}</strong></span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* Notes */}
                                {order.notes && (
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <FileText size={20} />
                                            ملاحظات
                                        </div>
                                        <div style={{ backgroundColor: '#fef3c7', padding: '0.75rem', borderRadius: '0.5rem' }}>
                                            {this.decodeArabicText(order.notes)}
                                        </div>
                                    </div>
                                )}

                                {/* History with Relative Time */}
                                {order.matab3alogs && order.matab3alogs.length > 0 && (
                                    <div style={styles.section}>
                                        <div style={styles.sectionTitle}>
                                            <Clock size={20} />
                                            سجل المتابعة
                                        </div>
                                        {order.matab3alogs.map((log, index) => (
                                            <div key={index} style={styles.historyItem}>
                                                <div><strong>{this.decodeArabicText(log.user.name)}</strong> - {this.decodeArabicText(log.status)}</div>
                                                <div style={styles.timeStamp}>
                                                    {this.formatRelativeTime(log.updatedAt)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}

                                {/* Order Info */}
                                <div style={styles.section}>
                                    <div style={styles.sectionTitle}>
                                        <Building2 size={20} />
                                        معلومات إضافية
                                    </div>
                                    <div style={styles.customerInfo}>
                                        <div><strong>مثبت الطلب:</strong> {this.decodeArabicText(order.user.name)}</div>
                                        <div><strong>الحالة الحالية:</strong> {this.decodeArabicText(order.calls)}</div>
                                    </div>
                                </div>

                                {/* Process Button */}
                                <button style={styles.processButton} onClick={() => this.openModal(order.id)}>
                                    معالجة
                                </button>
                            </div>
                        ))
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                        <div style={styles.pagination}>
                            {/* أزرار التنقل */}
                            <div style={styles.paginationNavButtons}>
                                <button
                                    style={{
                                        ...styles.paginationButton,
                                        ...(this.isMobile() ? styles.paginationButtonMobile : {}),
                                        ...(hasPrevPage ? {} : styles.paginationButtonDisabled)
                                    }}
                                    onClick={this.handlePrevPage}
                                    disabled={!hasPrevPage}
                                >
                                    <ChevronRight size={this.isMobile() ? 14 : 16} />
                                    {this.isMobile() ? '' : 'السابق'}
                                </button>

                                <button
                                    style={{
                                        ...styles.paginationButton,
                                        ...(this.isMobile() ? styles.paginationButtonMobile : {}),
                                        ...(hasNextPage ? {} : styles.paginationButtonDisabled)
                                    }}
                                    onClick={this.handleNextPage}
                                    disabled={!hasNextPage}
                                >
                                    {this.isMobile() ? '' : 'التالي'}
                                    <ChevronLeft size={this.isMobile() ? 14 : 16} />
                                </button>
                            </div>

                            {/* أرقام الصفحات */}
                            <div style={styles.paginationNumbers}>
                                {this.renderPaginationNumbers().map(page => (
                                    <button
                                        key={page}
                                        style={{
                                            ...styles.paginationButton,
                                            ...(this.isMobile() ? styles.paginationButtonMobile : {}),
                                            ...(page === currentPage ? styles.paginationButtonActive : {})
                                        }}
                                        onClick={() => this.handlePageChange(page)}
                                    >
                                        {page}
                                    </button>
                                ))}
                            </div>

                            {/* معلومات الصفحة */}
                            <div style={styles.paginationInfo}>
                                صفحة {currentPage} من {totalPages}
                            </div>
                        </div>
                    )}
                </div>

                {/* Modal */}
                {showModal && (
                    <div style={styles.modal}>
                        <div style={styles.modalContent}>
                            <div style={styles.modalTitle}>تحديث حالة الطلب</div>

                            {statusOptions.map(status => (
                                <div
                                    key={status}
                                    style={{
                                        ...styles.statusOption,
                                        ...(selectedStatus === status ? (
                                            status === 'تم المعالجة' ? styles.statusOptionCompleted : styles.statusOptionSelected
                                        ) : {})
                                    }}
                                    onClick={() => this.handleStatusChange(status)}
                                >
                                    {status === 'تم المعالجة' && selectedStatus === status && '✓ '}
                                    {status}
                                </div>
                            ))}

                            {selectedStatus === 'مؤجل' && (
                                <input
                                    type="date"
                                    value={postponeDate}
                                    onChange={this.handleDateChange}
                                    style={styles.dateInput}
                                    placeholder="تاريخ التأجيل"
                                />
                            )}

                            <div style={styles.modalButtons}>
                                <button
                                    style={{ ...styles.modalButton, ...styles.submitButton }}
                                    onClick={this.handleSubmit}
                                    disabled={!selectedStatus || (selectedStatus === 'مؤجل' && !postponeDate)}
                                >
                                    {selectedStatus === 'تم المعالجة' ? '✓ تأكيد المعالجة' : 'تأكيد'}
                                </button>
                                <button
                                    style={{ ...styles.modalButton, ...styles.cancelButton }}
                                    onClick={this.closeModal}
                                >
                                    إلغاء
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default OrderDetailsPage;